import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'

export function SecureRoute(): JSX.Element {
  const { oktaAuth, authState } = useOktaAuth()

  useEffect(() => {
    if (!authState) {
      return
    }

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      )
      oktaAuth.setOriginalUri(originalUri)
      oktaAuth.signInWithRedirect()
    }
  }, [oktaAuth, authState?.isAuthenticated, authState])

  if (!authState || !authState?.isAuthenticated) {
    return <h3 id="loading-icon">Loading...</h3>
  }

  return <Outlet />
}
